import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FieldProps } from "react-jsonschema-form";
import styled from "styled-components";
import {
  GetLoyaltyTiersByBrandRequest,
  LoyaltyConstantTier,
  LoyaltyDerivedTier,
} from "../../../gen/witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_pb";
import { useGrpcClient } from "../../../lib/grpc";
import { LoyaltyTierAPIPromiseClient } from "../../../gen/witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_grpc_web_pb";
import { useLoyaltyBrand } from "../../../components/loyalty-brand-provider";
import Selector from "../../../components/selector";

const StyledSelector = styled(Selector)`
  max-width: 200px;
  z-index: 9999;
`;

export function LoyaltyConstantTierSelectorMulti({
  formData,
  onChange,
  rawErrors,
  disabled,
  id,
  schema,
  isMulti,
}: FieldProps) {
  const brand = useLoyaltyBrand()?.ticker || "";

  const [constantTiers, setConstantTiers] = useState<
    (LoyaltyConstantTier.AsObject | LoyaltyDerivedTier.AsObject | undefined)[] | undefined
  >();
  const tierClient = useGrpcClient(LoyaltyTierAPIPromiseClient);

  useEffect(() => {
    const asyncFun = async () => {
      if (!constantTiers) {
        const request = new GetLoyaltyTiersByBrandRequest();
        request.setBrandTicker(brand);
        const response = await tierClient.getLoyaltyTiersByBrand(request);
        if (response) {
          const res = response.toObject();
          setConstantTiers(res.tiersList.map(it => it.constantTier).filter(it => it));
        }
      }
    };
    asyncFun();
  }, [constantTiers, tierClient, brand]);

  const tiersOptions = useMemo(() => {
    if (constantTiers?.length) {
      return constantTiers.map(tier => ({ value: tier?.externalSystemId, label: tier?.ticker }));
    }
    return [];
  }, [constantTiers]);

  const handleChange = useCallback(
    tiers => {
      onChange(tiers.map((tier: { value: string; label: string }) => tier.value));
    },
    [onChange]
  );
  const organizationValue = useMemo(() => {
    if (formData) {
      return tiersOptions.filter(it => formData.includes(it?.value));
    }
  }, [tiersOptions, formData]);
  return (
    <>
      <label>{schema?.title}</label>
      <StyledSelector
        options={tiersOptions}
        value={organizationValue}
        onChange={handleChange}
        isMulti={true}
      />
    </>
  );
}
